module.exports = __webpack_public_path__ + "img/020.05db81b0.jpg";